<template>
  <div v-show="data.isAccess" :class="['card create', selected_lang]">
    <div v-if="data.displayStatus.theme" class="header">
      <h2 v-text="$t('mov_making.mov_title1')"></h2>
    </div>
    <div v-if="data.displayStatus.theme" class="body">
      <div class="contents">
        <div class="flow-type1 flow-type">
          <span
            class="sr-only"
            v-text="$t('mov_making.desc_video_type1')"
          ></span>
        </div>
        <button
          type="button"
          class="btn-next"
          v-html="$t('mov_making.btn_video_type1')"
          @click="onLink(1)"
        ></button>
      </div>
    </div>
    <div v-if="data.displayStatus.upload" class="header">
      <h2 v-text="$t('mov_making.mov_title2')"></h2>
    </div>
    <div v-if="data.displayStatus.upload" class="body">
      <div class="contents">
        <div class="flow-type2 flow-type">
          <span
            class="sr-only"
            v-text="$t('mov_making.desc_video_type2')"
          ></span>
        </div>
        <button
          type="button"
          class="btn-next"
          @click="onLink(2)"
          v-html="$t('mov_making.btn_video_type2')"
        ></button>
      </div>
    </div>
    <div v-if="data.displayStatus.upload_effect" class="header">
      <h2
        v-html="
          $t('mov_making.mov_title3', {
            isInsertEnter: data.isInsertEnter ? '<br>' : '',
          })
        "
      ></h2>
    </div>
    <div v-if="data.displayStatus.upload_effect" class="body">
      <div class="contents">
        <div class="flow-type3 flow-type">
          <span
            class="sr-only"
            v-text="$t('mov_making.desc_video_type3')"
          ></span>
        </div>
        <button
          type="button"
          class="btn-next"
          @click="onLink(3)"
          v-html="$t('mov_making.btn_video_type3')"
        ></button>
      </div>
    </div>
    <div v-if="data.displayStatus.image" class="header">
      <h2 v-text="$t('mov_making.mov_title4')"></h2>
    </div>
    <div v-if="data.displayStatus.image" class="body">
      <div class="contents">
        <div class="flow-type4 flow-type">
          <span
            class="sr-only"
            v-text="$t('mov_making.desc_video_type4')"
          ></span>
        </div>
        <button
          type="button"
          class="btn-next"
          @click="onLink(4)"
          v-html="$t('mov_making.btn_video_type4')"
        ></button>
      </div>
    </div>
    <div v-if="data.displayStatus.picture" class="header">
      <h2 v-text="$t('mov_making.mov_title5')"></h2>
    </div>
    <div v-if="data.displayStatus.picture" class="body">
      <div class="contents">
        <div class="flow-type4 flow-type">
          <span
            class="sr-only"
            v-text="$t('mov_making.desc_video_type4')"
          ></span>
        </div>
        <button
          type="button"
          class="btn-next"
          @click="onLink(5)"
          v-html="$t('mov_making.btn_video_type4')"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import userInfo from '@src/mixins/userInfo';
import EventBus from '@utils/bus';
import { isMobile } from '@action/util';

const data = {
  step_list: [],
  product_type_id: '',
  is_click: true,
  role_code: '',
  isInsertEnter: false,
  isAccess: false,
  displayStatus: {
    theme: false,
    upload: false,
    upload_effect: false,
    image: false,
    picture: false,
  },
  feature: {},
  featureStatus: {},
};

export default {
  name: 'select_video_type',
  head: {
    title: {
      inner: 'select_video_type',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Video Of Smart Solution',
      },
    ],
  },
  mixins: [userInfo],
  data() {
    return {
      data,
      access_type: '',
      selected_lang: '',
      q: {
        screen_type: '',
      },
      device_vender: '',
    };
  },
  created() {
    data.role_code = sessionStorage.getItem('role_code');
    this.access_type = sessionStorage.getItem('access_type');
    data.isInsertEnter = sessionStorage.getItem('access_type') === 'app';
    this.selected_lang = Cookies.get(Common.STORAGE_LANG);
    this.q.screen_type = this.$route.query.screen_type;
  },
  methods: {
    getDeviceVender() {
      let deviceVender = '';

      if (sessionStorage.getItem('user_info')) {
        const userId = JSON.parse(sessionStorage.getItem('user_info')).user
          .user_id;
        deviceVender = this.$store.dispatch('FETCH_DEVICE_VENDER', {
          id: userId,
        });
      }

      return deviceVender;
    },
    async userInfoCallback() {
      const deviceVender = await this.getDeviceVender();
      this.device_vender = deviceVender.vender;

      data.displayStatus.theme =
        this.q.screen_type !== 'video2' &&
        this.device_vender !== 'NEXCO-A' &&
        data.featureStatus.mov &&
        !data.product_type_id.startsWith('S');

      data.displayStatus.upload = true;
      data.displayStatus.upload_effect =
        this.device_vender !== 'NEXCO-A' && data.featureStatus.mov;
      data.displayStatus.image =
        this.device_vender !== 'NEXCO-A' && data.featureStatus.mov;
      data.displayStatus.picture = !isMobile();
    },
    onLink(value) {
      if (data.product_type_id === '') {
        if (data.is_click) {
          alert(eve.Lang.t('common.t_not_exist_sign'));
          data.is_click = !data.is_click;
          // 타이밍 추가
          setTimeout(() => {
            data.is_click = true;
          }, 3000);
        }

        return;
      }

      const result = {
        type: Common.EVT_CB_SCREEN_TYPE,
        screen_type: '',
      };

      if (value === 1) {
        // 테마 사용하여 제작하기 STEP 1
        result.screen_type = 'theme';
      } else if (value === 2) {
        // 업로드 사용하여 제작하기 STEP 1
        result.screen_type = 'upload';
      } else if (value === 3) {
        // 업로드 사용하여 제작하기(문구 효과 사용) STEP 1
        result.screen_type = 'upload-effect';
      } else if (value === 4) {
        // 사진 사용하여 제작하기 STEP 1
        result.screen_type = 'image';
        result.data = {
          product_type_id: data.product_type_id,
          step_type: 'image',
        };
      } else if (value === 5) {
        // 사진 사용하여 제작하기 STEP 1
        result.screen_type = 'picture';
        result.data = {
          product_type_id: data.product_type_id,
          step_type: 'picture',
        };
      }

      EventBus.$emit('childs-event', result);
    },
  },
};
</script>

<style scoped lang="scss">
.video.web,
.video.app {
  .card.create {
    padding: 24px 0;

    .header {
      padding: 0 24px;
    }

    .body {
      padding: 0 24px;
    }
  }
}

.card.create {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 100%;
  background-color: $white;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  counter-reset: section;

  &.ko {
    .flow-type1 {
      background-image: url(~@assets/images/create-video/flow-type-ko1.png);
    }

    .flow-type2 {
      background-image: url(~@assets/images/create-video/flow-type-ko2.png);
    }

    .flow-type3 {
      background-image: url(~@assets/images/create-video/flow-type-ko3.png);
    }

    .flow-type4 {
      background-image: url(~@assets/images/create-video/flow-type-ko4.png);
    }
  }

  &.ja {
    .flow-type1 {
      background-image: url(~@assets/images/create-video/flow-type-ja1.png);
    }

    .flow-type2 {
      background-image: url(~@assets/images/create-video/flow-type-ja2.png);
    }

    .flow-type3 {
      background-image: url(~@assets/images/create-video/flow-type-ja3.png);
    }

    .flow-type4 {
      background-image: url(~@assets/images/create-video/flow-type-ja4.png);
    }
  }

  &.en {
    .flow-type1 {
      background-image: url(~@assets/images/create-video/flow-type-en1.png);
    }

    .flow-type2 {
      background-image: url(~@assets/images/create-video/flow-type-en2.png);
    }

    .flow-type3 {
      background-image: url(~@assets/images/create-video/flow-type-en3.png);
    }

    .flow-type4 {
      background-image: url(~@assets/images/create-video/flow-type-en4.png);
    }
  }

  .header {
    h2 {
      margin-bottom: 0;
      padding-bottom: 10px;
      border-bottom: 2px solid #aaaaaa;
      font-weight: 500;
      font-size: 26px;
      color: #000000;

      &::before {
        counter-increment: section;
        content: counter(section) '.';
      }
    }
  }

  .body {
    margin-top: 20px;
    background-color: $white;

    .contents {
      display: flex;
      width: 100%;
      max-width: 978px;
      margin: 0 auto;

      .flow-type {
        width: calc(100% - 185px);
        height: 132px;
        border-radius: 10px;
        background-color: #eeeeee;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 110% auto;
        transition: all 0.3s;
      }

      .btn-next {
        width: 165px;
        margin-left: 20px;
        padding: 10px;
        border-radius: 10px;
        background-image: url(~@assets/images/create-video/btn-video-type.png);
        background-size: 100% 100%;
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        text-shadow: -0.9px 0.5px 6px rgba(0, 0, 0, 0.2);
        transition: all 0.3s;

        &:focus,
        &:hover {
          background-image: linear-gradient(to bottom, #009eff, #00bbff);
        }
      }
    }
  }

  .body + .header {
    margin-top: 24px;
    border-top: 12px solid #e5e5e5;

    h2 {
      margin-top: 20px;
    }
  }
}

@media (max-width: 991px) {
  .card.create {
    .header {
      h2 {
        font-size: 18px;
      }
    }

    .body {
      .contents {
        display: block;

        .flow-type {
          width: 100%;
          height: 102px;
        }

        .btn-next {
          width: 100%;
          margin-top: 5px;
          margin-left: 0;
          background-image: linear-gradient(to bottom, #00bbff, #009eff);
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 639px) {
  .card.create {
    .header {
      h2 {
        font-size: 16px;
      }
    }

    .body {
      .contents {
        .flow-type {
          height: 92px;
        }

        .btn-next {
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .video.web,
  .video.app {
    .card.create {
      padding: 12px 0;

      .header {
        h2 {
          margin-top: 15px;
          border-bottom-width: 1px;
          font-size: 14px;
        }
      }

      .body {
        margin-top: 10px;

        .contents {
          .flow-type {
            height: 72px;
          }

          .btn-next {
            padding: 5px;
            font-size: 12px;
          }
        }
      }

      .body + .header {
        margin-top: 12px;
        border-top-width: 6px;
      }
    }
  }
}
</style>
